"use client";

import { c as _c } from "react/compiler-runtime";
import { AdjustmentsHorizontalIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import SearchFilter from "./search";
import SearchToggles from "./toggles";
export default function Filter() {
  const $ = _c(11);
  const [drawerVisible, setDrawerVisible] = useState(false);
  let t0;
  let t1;
  if ($[0] !== drawerVisible) {
    t0 = () => {
      if (drawerVisible) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    };
    t1 = [drawerVisible];
    $[0] = drawerVisible;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function openDrawer() {
      setDrawerVisible(true);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const openDrawer = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function closeDrawer() {
      setDrawerVisible(false);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const closeDrawer = t3;
  const t4 = !drawerVisible;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div onClick={closeDrawer} aria-hidden="true" className={twMerge("fixed left-0 top-0 z-50 hidden h-full w-full backdrop-blur-md", "group-data-[mobile-hidden=false]:block group-data-[mobile-hidden=false]:backdrop-blur-md")} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <button onClick={openDrawer} aria-label={"\xD6ppna filtermeny"} className={twMerge("fixed bottom-4 right-4 z-50 rounded-full bg-slate-50 p-4 shadow-md dark:bg-slate-800", "sm:hidden")}><AdjustmentsHorizontalIcon className="h-10 w-10" /></button>;
    t7 = twMerge("top-0 z-50 h-dvh overflow-y-scroll shadow-xs", "bg-white transition-transform dark:bg-slate-800", "w-drawer translate-x-(--width-drawer) fixed right-0 pt-12 group-data-[mobile-hidden=false]:translate-x-0", "sm:group-data-[mobile-hidden=true]:top-header-sm-with-margin sm:group-data-[mobile-hidden=true]:max-h-full-without-header", "sm:group-data-[mobile-hidden=true]:sticky sm:group-data-[mobile-hidden=true]:transform-none", "sm:group-data-[mobile-hidden=true]:z-0 sm:group-data-[mobile-hidden=true]:h-min sm:group-data-[mobile-hidden=true]:w-auto", "sm:group-data-[mobile-hidden=true]:min-w-[17rem] sm:group-data-[mobile-hidden=true]:rounded-xs sm:group-data-[mobile-hidden=true]:pt-0", "sm:group-data-[mobile-hidden=true]:translate-x-0", "sm:transition-none");
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={t7}><button onClick={closeDrawer} aria-label={"St\xE4ng filtermeny"} className={twMerge("absolute right-4 top-4", "sm:group-data-[mobile-hidden=true]:hidden")}><XMarkIcon className="text-red h-8 w-8" /></button><SearchFilter /><SearchToggles /></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t4) {
    t9 = <div data-mobile-hidden={t4} className="group">{t5}{t6}{t8}</div>;
    $[9] = t4;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
}